import update from "immutability-helper";
import _ from "lodash";

import {
  //Редактирование формы опроса
  SET_POLL_NAME,
  TOGGLE_CLIENTS_TYPE,
  TOGGLE_CONSULTANTS_TYPE,
  SET_ANSWER_NAME,
  ADD_NEW_ANSWER,
  DELETE_ANSWER,
  //Загрузка информации об опросе
  EDITING_POLL_LOADING_START,
  EDITING_POLL_LOADED_SUCCESSFULLY, 
  EDITING_POLL_LOADING_FAILED,
  //Редактирование опроса
  POLL_EDITING_START,
  POLL_EDITED_SUCCESSFULLY,
  POLL_EDITING_FAILED,
  //Создание опроса
  POLL_CREATION_START,
  POLL_CREATED_SUCCESSFULLY,
  POLL_CREATION_FAILED,
  //Другое
  CLEAR_POLL_FORM,
} from "../actions/editPoll";

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: true,
  loading: false,
  poll: {
    id: 0,
    text: '',
    type: 'clients',
    answers: [
      {
        text: '',
      }, 
      {
        text: '',
      }
    ],
    clients: false,
    consultants: false,
  },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    //Редактирование и создание опроса
    case EDITING_POLL_LOADED_SUCCESSFULLY:
      let loadedPoll = action.payload.poll;
      switch (loadedPoll.type) {
        case 'CLIENTS':
          loadedPoll.clients = true;
          loadedPoll.consultants = false;
          break;
        case 'CONSULTANTS':
          loadedPoll.clients = false;
          loadedPoll.consultants = true;
          break;
        case 'ALL':
          loadedPoll.clients = true;
          loadedPoll.consultants = true;
          break;
        default:
          loadedPoll.clients = false;
          loadedPoll.consultants = false;
      }
      loadedPoll = _.omit(loadedPoll, ['created_at', 'vote_count', 'status', 'type']);
      return {
        ...state,
        ready: true,
        loading: false,
        poll: loadedPoll,
      };
    case EDITING_POLL_LOADING_FAILED:
    case POLL_EDITING_FAILED:
    case POLL_CREATION_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Редактирование опроса
    case EDITING_POLL_LOADING_START:
    case POLL_EDITING_START:
    case POLL_CREATION_START:
      return {
        ...state,
        ready: false, 
        loading: true,
      };
    case POLL_EDITED_SUCCESSFULLY:
    case POLL_CREATED_SUCCESSFULLY:
    case CLEAR_POLL_FORM:
      return INITIAL_STATE;
    //Редактирование формы опроса
    case SET_POLL_NAME:
      return update(state, {
        poll: {
          text: {$set: action.payload.value},
        }
      });
    case TOGGLE_CLIENTS_TYPE:
      return update(state, {
        poll: {
          clients: {$set: !state.poll.clients},
        }
      });
    case TOGGLE_CONSULTANTS_TYPE:
      return update(state, {
        poll: {
          consultants: {$set: !state.poll.consultants},
        }
      });
    //Варианты ответов
    case SET_ANSWER_NAME:
      return update(state, {
        poll: {
          answers: {
            [action.payload.answerIndex]: {
              text: {$set: action.payload.value},
            }
          },
        }
      });
    case ADD_NEW_ANSWER:
      const newAnswer = { text: '' };
      return update(state, {
        poll: {
          answers: { $push: [newAnswer] },
        },
      });
    case DELETE_ANSWER:
      return update(state, {
        poll: {
          answers: { $splice: [[action.payload.answerIndex, 1]] },
        },
      });
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
